import { state, aiImages, aiBgElements } from '../core/state.mjs';
import { CONFIG } from '../core/config.mjs';
import { getCachedContainerWidth, invalidateMeasurementCache } from '../utils/cache.mjs';
import { getConnectionQuality } from '../utils/get_connection_quality.mjs';
import { imageTransform } from './image-transform.mjs';
import { backgroundTransform } from './background-transform.mjs';

/**
 * Met à jour les images selon taille fenêtre et qualité connexion
 */
export function imageUpdate(forceInit) {
    if (!forceInit) {
        invalidateMeasurementCache();
    }

    const isEnlarged = ((window.innerWidth - state.initialWidth) / state.initialWidth * 100) >= CONFIG.growth.threshold;
    const connection = getConnectionQuality();

    if (CONFIG.growth.useOriginal) {
        state.images.forEach((info, img) => {
            if (!img.isConnected) {
                state.images.delete(img);
                return;
            }

            const container = img.parentElement;
            if (!container) return;

            const containerWidth = getCachedContainerWidth(container);
            if (!containerWidth) return;

            if (forceInit && !info.initialContainerWidth) {
                info.initialContainerWidth = containerWidth;
            }

            const initialWidth = info.initialContainerWidth || info.initialWidth;
            const containerEnlarged = ((containerWidth - initialWidth) / initialWidth * 100) >= CONFIG.growth.threshold;

            const shouldUseOriginal = info.useOriginal || (
                isEnlarged && containerEnlarged && connection.isGoodEnough
            );

            if (forceInit || shouldUseOriginal !== info.useOriginal) {
                if (shouldUseOriginal) {
                    // Créer image avec URL originale
                    const newImg = document.createElement('img');
                    newImg.alt = img.alt || '';
                    if (img.id) newImg.id = img.id;
                    if (img.className) newImg.className = img.className.replace('lazy-image', '');

                    newImg.onload = function () {
                        newImg.classList.add('ai-loaded');
                    };

                    const formatParam = info.format ? `&format=${info.format}` : '';
                    newImg.src = `${info.src}${formatParam}&org_if_sml=1`;

                    if (img.parentNode) {
                        img.parentNode.replaceChild(newImg, img);
                        state.images.set(newImg, { ...info, useOriginal: true });
                        state.images.delete(img);
                    }
                } else if (!forceInit) {
                    // Revenir à l'image optimisée
                    const parent = img.parentNode;
                    if (parent) {
                        const tempImg = document.createElement('img');
                        tempImg.setAttribute('ai-src', info.src);
                        tempImg.alt = img.alt || '';
                        parent.replaceChild(tempImg, img);

                        // Mise à jour du tableau au lieu de réassignation
                        aiImages.length = 0;
                        aiImages.push(tempImg);
                        imageTransform();
                        state.images.delete(img);
                    }
                }
            }
        });

        state.backgrounds.forEach((info, el) => {
            if (!el.isConnected) {
                state.backgrounds.delete(el);
                return;
            }

            const containerWidth = getCachedContainerWidth(el);
            if (!containerWidth) return;

            if (forceInit && !info.initialContainerWidth) {
                info.initialContainerWidth = containerWidth;
            }

            const initialWidth = info.initialContainerWidth || info.initialWidth;
            const containerEnlarged = ((containerWidth - initialWidth) / initialWidth * 100) >= CONFIG.growth.threshold;

            const shouldUseOriginal = info.useOriginal || (
                isEnlarged && containerEnlarged && connection.isGoodEnough
            );

            if (forceInit || shouldUseOriginal !== info.useOriginal) {
                if (shouldUseOriginal) {
                    const formatParam = info.format ? `&format=${info.format}` : '';
                    const originalUrl = `${info.src}${formatParam}&org_if_sml=1`;

                    const tempImg = new Image();
                    tempImg.onload = function () {
                        el.style.backgroundImage = `url("${originalUrl}")`;
                    };
                    tempImg.src = originalUrl;

                    info.useOriginal = true;
                } else if (!forceInit) {
                    el.setAttribute('ai-bg-src', info.src);
                    state.backgrounds.delete(el);

                    // Mise à jour du tableau au lieu de réassignation
                    aiBgElements.length = 0;
                    aiBgElements.push(el);
                    backgroundTransform();
                }
            }
        });
    }
}
